import columnFixChange from '@/directives/columnFixChange';

const columnResize = (el, binding) => {

  const { nodeName } = el;
  // 테이블에 붙은 경우에만 실행된다.
  if (['TABLE'].indexOf(nodeName) < 0) return;
  const { expression } = binding;
  // binding 된 파라미터에서 숫자와 , 만 남기고 배열로 변환
  if (!expression) return;
  let columnIdxs = expression
    .replace(/[^0-9,]/g, '')
    .split(',')
    .map(exp => {
      const expInt = parseInt(exp);
      if (typeof expInt === 'number') return expInt;
      return null;
    });
  if (isNaN(columnIdxs[0])) {
    columnIdxs = binding.value
      .replace(/[^0-9,]/g, '')
      .split(',')
      .map(exp => {
        const expInt = parseInt(exp);
        if (typeof expInt === 'number') return expInt;
        return null;
      });
  }

  const table = el;
  const parentDiv = el.parentElement;

  const colGroup = table.querySelector('colgroup');
  const cols = colGroup.querySelectorAll('col');
  const thead = table.querySelector('thead');
  const ths = thead.querySelectorAll('th');

  const barHeight = table.offsetHeight;
  const resizeContainer = parentDiv.querySelector('.vue-columns-resizable')
    ? parentDiv.querySelector('.vue-columns-resizable')
    : document.createElement('div');
  let bars;

  let moving = false;
  let movingIndex = 0;
  let afterScrollLeft = 0;

  if (!parentDiv.querySelector('.vue-columns-resizable')) {
    resizeContainer.className = 'vue-columns-resizable';
    table.parentElement.insertBefore(resizeContainer, table);
  }
  function init() {
    const scrollBarWidth = Math.abs(parentDiv.offsetWidth - table.clientWidth);
    let colWidthAdjust = 0;
    if (scrollBarWidth < 20 && scrollBarWidth > 0) colWidthAdjust = Math.ceil(scrollBarWidth / cols.length);
    cols.forEach((col) => {
      if (col.width) {
        col.style.width = col.width;
        col.width = '';
      }
      col.style.width = (col.offsetWidth - colWidthAdjust) < 41 ? '41px' : `${col.offsetWidth - colWidthAdjust}px`;
    });

    resizeContainer.innerHTML = '';
    cols.forEach((col, index) => {
      if (index + 1 >= cols.length) return;
      const bar = document.createElement('div');
      const nextCol = cols[index + 1];
      // binding된 파라미터의 column만 적용
      if (columnIdxs.indexOf(index) > -1) {
        bar.style.position = 'absolute';
        bar.style.left = `${nextCol.offsetLeft - 4}px`;
        bar.style.height = `${barHeight}px`;
        bar.style.width = '8px';
        bar.style.cursor = 'col-resize';
        bar.style.zIndex = 99999;
        bar.className = 'columns-resize-bar';
        // 마우스 클릭 시 이동 가능 상태로 변경한다.
        bar.addEventListener('mousedown', () => {
          moving = true;
          movingIndex = index;
          document.body.style.cursor = 'col-resize';
          document.body.style.userSelect = 'none';
        });
        resizeContainer.appendChild(bar);
      }
    });
    bars = resizeContainer.querySelectorAll('.columns-resize-bar');
    cols.forEach((col) => {
      col.style.width = (col.offsetWidth - colWidthAdjust) < 41 ? '41px' : `${col.offsetWidth - colWidthAdjust}px`;
    });
  }
  init();

  function adjustBarLeft() {
    afterScrollLeft = parentDiv.scrollLeft;
    bars.forEach((bar, index) => {
      let offsetWidthSum = 0;
      let stickyWidthSum = 0;
      for (let idx = 0; idx <= columnIdxs[index]; idx += 1) {
        const th = ths[idx];
        if (!th.dataset.fix) offsetWidthSum += cols[idx].offsetWidth;
        else stickyWidthSum += cols[idx].offsetWidth;
      }
      const screenWidth = offsetWidthSum - afterScrollLeft <= 0 ? offsetWidthSum : afterScrollLeft;
      const left = offsetWidthSum + stickyWidthSum - screenWidth;
      bar.style.left = `${left - 4}px`;
      bar.style.zIndex = 99999;
    });
  }
  const handleResize = e => {
    if (moving) {
      const col = cols[movingIndex];
      const nextCol = cols[movingIndex + 1];
      if (nextCol.offsetWidth - e.movementX <= 40 || col.offsetWidth + e.movementX <= 40) return;
      col.style.width = `${Number(col.style.width.slice(0, col.style.width.length - 2)) + e.movementX}px`;
      nextCol.style.width = `${Number(nextCol.style.width.slice(0, nextCol.style.width.length - 2)) - e.movementX}px`;
    }
    adjustBarLeft();
  };
  const mouseup = () => {
    if (!moving) return;

    moving = false;
    document.body.style.cursor = '';
    document.body.style.userSelect = '';

    if (columnFixChange) columnFixChange(el);
    adjustBarLeft();
  };
  document.addEventListener('mouseup', mouseup);
  resizeContainer.removeEventListener('mousemove', handleResize);
  table.removeEventListener('mousemove', handleResize);
  parentDiv.removeEventListener('scrollend', adjustBarLeft);
  resizeContainer.addEventListener('mousemove', handleResize);
  table.addEventListener('mousemove', handleResize);
  parentDiv.addEventListener('scrollend', adjustBarLeft);
};
export default {
  inserted(el, binding) {
    columnResize(el, binding);
  },
  componentUpdated(el, binding) {
    columnResize(el, binding);
  },
};



// WEBPACK FOOTER //
// ./src/directives/columnResize.js